// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function PdfLoading(Props) {
  let width = Props.width;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const height = Math.floor(deviceType === "mobile" ? width * 1.224 : width / 1.413) | 0;
  const match = React.useState(function () {
    return false;
  });
  const setStartTransition = match[1];
  React.useEffect((function () {
    Curry._1(setStartTransition, (function (param) {
      return true;
    }));
  }), []);
  return JsxRuntime.jsxs("div", {
    children: [
      deviceType === "mobile" ? JsxRuntime.jsx("img", {
          className: "w-[48px] h-[60px]",
          alt: "pdf",
          src: StaticAsset.src("/static/icons/pdf-mobile.svg")
        }) : JsxRuntime.jsx("img", {
          className: "w-[68px] h-[93px]",
          alt: "pdf",
          src: StaticAsset.src("/static/icons/pdf.svg")
        }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          className: Cn.fromList({
            hd: "h-0.5 bg-links hover:bg-links-hover active:bg-links-active transition-[width duration-[4000ms]",
            tl: {
              hd: match[0] ? (
                  deviceType === "mobile" ? "w-[196px]" : "w-[236px]"
                ) : "w-0",
              tl: /* [] */ 0
            }
          })
        }),
        className: Cn.fromList({
          hd: "bg-gray-light",
          tl: {
            hd: deviceType === "mobile" ? "w-50 mt-6" : "w-60 mt-10",
            tl: /* [] */ 0
          }
        })
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "mt-4 text-default-gray",
        children: "Загружаем документ..."
      })
    ],
    className: "bg-white flex flex-col items-center justify-center",
    style: {
      height: String(height) + "px",
      width: String(width) + "px"
    }
  });
}

const make = PdfLoading;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
